import React, { useState } from 'react';
import {
  Box,
  Button,
  HStack,
  Text,
  useDisclosure,
  VStack
} from '@chakra-ui/react';
import { useDispatch } from 'react-redux';
import { MdRocketLaunch } from 'react-icons/md';
import ModalLayout from '@components/Modal/ModalLayout';
import DynamicInputModal from '@components/DynamicInputModal';
import { INPUT_FIELD_TYPE } from '@components/DynamicFormField/constant';
import api from '@api/endpoints';
import { setAlert } from '@store/actions/alertActions';
import { ALERT_STATUS_TYPE } from '@constants';
import { getErrorMessage } from '@utils';

const ForceInitiateFulfillment = ({ fulfillmentData, onSuccess }) => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  const {
    isOpen: isConfirmModalOpen,
    onOpen: onConfirmModalOpen,
    onClose: onConfirmModalClose
  } = useDisclosure();

  const fields = [
    {
      name: 'release',
      label: 'Action Type',
      fieldType: INPUT_FIELD_TYPE.RADIO,
      value: 'release',
      defaultValue: 'false',
      isRequired: true,
      options: [
        {
          label: 'Fail',
          value: 'false'
        },
        {
          label: 'Release',
          value: 'true'
        }
      ]
    }
  ];

  const handleForceInitiate = async (formData) => {
    setIsLoading(true);
    try {
      await api.gomsFulfillment.forceInitiateGomsFulfillmentWithRelease({
        orderId: fulfillmentData?.orderId,
        release: formData.release === 'true'
      });

      dispatch(
        setAlert({
          title: `Successfully force ${formData.release === 'true' ? 'released' : 'failed'} fulfillment for order ${fulfillmentData?.orderId}`,
          status: ALERT_STATUS_TYPE.SUCCESS
        })
      );

      if (onSuccess) {
        onSuccess();
      }
    } catch (error) {
      dispatch(
        setAlert({
          title: getErrorMessage({
            error,
            genericMessage: 'Failed to force initiate fulfillment'
          }),
          status: ALERT_STATUS_TYPE.ERROR
        })
      );
    } finally {
      setIsLoading(false);
      onConfirmModalClose();
    }
  };

  return (
    <Box>
      <ModalLayout isOpen={isConfirmModalOpen} onClose={onConfirmModalClose}>
        <DynamicInputModal
          title="Update TRM"
          onClose={onConfirmModalClose}
          onSubmit={handleForceInitiate}
          fields={fields}
          isLoading={isLoading}
        />
      </ModalLayout>

      <HStack
        w="100%"
        gap={2}
        alignSelf="start"
        justifyContent="space-between"
        border="1px solid"
        borderColor="whiteAlpha.500"
        bg="backGround"
        borderRadius="12px"
        p={4}
      >
        <VStack alignItems="start" spacing={1} flex={1}>
          <Text fontSize="md" fontWeight="semibold" color="white">
            Update TRM
          </Text>
          <Text fontSize="xs" color="whiteAlpha.600">
            Choose to release or fail this fulfillment
          </Text>
        </VStack>
        <Button
          colorScheme="brand"
          size="sm"
          bg="backGround"
          border="2px solid"
          borderColor="whiteAlpha.500"
          borderRadius="full"
          p={4}
          leftIcon={<MdRocketLaunch />}
          onClick={onConfirmModalOpen}
        >
          Update TRM
        </Button>
      </HStack>
    </Box>
  );
};

export default ForceInitiateFulfillment;
